const pl = {
    appOutsideMsTeams: {
        message: "Aplikacja musi być uruchomiona w kontekście Microsoft Teams",
    },
    common: {
        appLoading: "Wczytywanie danych...",
        close: "Zamknij",
        appName: "PinPoint",
        confirm: "Potwierdź",
        yes: "TAK",
        no: "NIE",
        siteUnderConstruction: "Funkcjonalność dostępna wkrótce",
        continue: "Kontynuuj",
        send: "Wyślij",
        cancel: "Anuluj",
        noData: "Brak danych",
        tabUnavailable: "Strona niedostępna",
        noTabsUnavailable: "Nie posiadasz uprawnień do żadnego z modułów aplikacji PinPoint",
        hide: "Zwiń",
        showMore: (limit: number) => {
            return `Pokaż więcej (${limit})`;
        },
        year: "Rok",
        save: "Zapisz",
        add: "Dodaj",
        edit: "Edytuj",
        delete: "Usuń",
        dropdownNoResultMessage: "Nie znaleźliśmy żadnych dopasowań.",
        dropdownDeleteMessage: "Naciśnij klawisz Delete lub Backspace, aby usunąć",
    },
    tabs: {
        tasks: "Zadania",
        goalsCard: "Cele",
        motivationCard: "Motywacja",
        powerBiReports: "Raporty",
        rmsPortal: "Informacje",
        view360: "Widok 360",
        userProfile: "Administracja",
        globalNotes: "Notatki",
    },
    configProvider: {
        loadConfigError: {
            header: "Wystąpił problem z pobraniem konfiguracji aplikacji",
            content:
                "Nie udało się pobrać konfiguracji aplikacji PinPoint. Odśwież stronę lub zaloguj się ponownie do aplikacji Microsoft Teams.",
        },
    },
    authProvider: {
        authError: {
            header: "Nie masz uprawnień do aplikacji PinPoint",
            content: "Skontakuj się z ...",
        },
        developmentAuth: {
            header: "Zaloguj się",
            message:
                "Wykorzystujesz developerską wersję aplikacji PinPoint. Aby uzyskać dostęp zaloguj się na jedno z kont testowych.",
            validationError: "Podaj właściwe dane",
            form: {
                login: "Nazwa użytkownika",
                password: "Hasło",
                submit: "Zaloguj się",
            },
        },
        adminAuth: {
            authError: "Wystąpił problem podczas przekierowania na zakładkę administratora",
        },
    },
    dictionaryProvider: {
        loadStatusesError: {
            header: "Wystąpił problem z pobraniem statusów zadań",
            content:
                "Nie udało się pobrać statusów zadań. Odśwież stronę lub zaloguj się ponownie do aplikacji Microsoft Teams.",
        },
    },
    taskBoard: {
        loading: "Wczytywanie zadań...",
        header: "Lista zadań | ",
        userDidNotProvideContactType: "Uzupełnij formę spotkania aby zamknąć zadanie.",
    },
    taskDetails: {
        loading: "Trwa ładowanie zadania...",
        dropdown: {
            placeholder: "Wybierz",
            saveChanges: "Zapisz zmiany",
            noResults: "Brak dopasowań",
            cancel: "Anuluj",
        },
        labels: {
            description: "Opis zadania",
            type: "Typ zadania",
            status: "Status zadania",
            assignedPerson: "Osoba przypisana",
            agency: "Agencja",
            recommendedContactType: "Rekomendowana forma kontaktu",
            contactType: "Wybrana forma spotkania",
            plannedDate: "Planowana data",
            autoCloseAfter: "Data autozamknięcia",
            causes: "Przyczyny",
            implementedActions: "Podjęte działania",
            attachments: "Załączniki",
            externalReferenceId: "Identyfikator zadania",
            ofwca: "OFWCA",
        },
        attachments: {
            loading: {
                add: "Trwa dodawanie załącznika",
                remove: "Trwa usuwanie załącznika",
                retreive: "Trwa pobieranie załącznika",
            },
            validationError: {
                header: "Nie udało się przesłać załącznika",
                contents: {
                    fileTooLarge: (fileSizeLimit: number) =>
                        `Nie możesz przesłać pliku większego niż ${fileSizeLimit}MB.`,
                    tooManyFiles: "Nie możesz przesłać więcej niż jednego pliku na raz.",
                    uploadFailed: "Przesyłanie załącznika zakończyło się niepowodzeniem.",
                },
            },
            dropzone: {
                dropToUpload: "Upuść plik, aby dodać go do zadania lub",
                browse: "wybierz z dysku",
            },
            add: "Dodaj załącznik",
            delete: "Usuń plik",
            confirmDeletionDialog: {
                header: "Usuń załącznik",
                content: (fileName: string) =>
                    `Czy na pewno chcesz usunąć załącznik ${fileName}? Operacja jest nieodwracalna.`,
            },
        },
        comment: {
            placeholder: "Wpisz komentarz...",
            add: "Dodaj",
            edit: {
                cancelAction: "Anuluj",
                deleteAction: "Usuń komentarz",
                editAction: "Edytuj komentarz",
                saveAction: "Zapisz zmiany",
                loader: "Trwa zapisywanie zmian...",
            },
            delete: {
                header: "Potwierdź usunięcie komentarza",
                message: "Czy na pewno chcesz usunąć ten komentarz?",
            },
        },
        taskDetailsDropdownConfirmationDialog: {
            header: "Potwierdź zmianę danych",
        },
        assignee: {
            changeByDPConfirmation: `Czy na pewno chcesz zmienić osobę przypisaną do tego zadania?
            Pojawi się ono na tablicy nowo przypisanej osoby. Nadal będziesz je widzieć na swojej tablicy.`,
            changeByMSConfirmation: `Czy na pewno chcesz zmienić osobę przypisaną do tego zadania?
            Zadanie to zniknie z Twojej tablicy.`,
        },
        closeTask: "Zakończ zadanie",
    },
    taskBoardTopBar: {
        filters: {
            allTagsPlaceholder: "Wszystkie tagi",
            allAgenciesAndSellersPlaceholder: "Wszystkie agencje i pośrednicy",
            noSuggestionsFound: "Brak wyników",
        },
    },
    reports: {
        headers: {
            companyReportsHeader: "Monitoring realizacji celów",
            tableHeader: "Monitoring realizacji celów - szczegóły",
            resultsRange: (startDate: string | undefined, endDate: string | undefined) =>
                `Wyniki za okres ${startDate}  -  ${endDate}`,
            dataProgress: (progressValue: string | undefined) => `Upływ czasu: ${progressValue}%`,
        },
        tabs: {
            monthly: "Miesięczny",
            quarterly: "Kwartalny",
            monthly_rms: "Ranking RMS",
        },
        noReportsAvailable: (companyName: string) => `Brak raportów miesięcznych dla ${companyName}`,
        loading: "Trwa ładowanie raportów...",
        targetProgressBar: {
            today: "Dzisiaj",
        },
        targetProgressInfo: {
            targetLabel: (amount: number) => `Do celu brakuje: ${amount}`,
        },
        managerReportCell: {
            targetLabel: (amount: number) => `Cel: ${amount}`,
            leftLabel: (amount: number) => `Pozostało ${amount}`,
        },
        salesNetworkTypes: {
            classic: "Sieć klasyczna",
            national: "Sieć krajowa",
        },
        companyTypes: {
            hestia: "EHM",
            hestiaLife: "EHŻ",
        },
        reportTable: {
            nameHeader: "Nazwa",
        },
        noReports: "Brak dostępnych raportów",
        summary: "Podsumowanie",
        summaryTitle: (entityTypeDisplayName: string, tenantDisplayName: string, showTenantDisplayName: boolean) =>
            `Podsumowanie${showTenantDisplayName ? " " + entityTypeDisplayName : ""} - ${tenantDisplayName}`,
    },
    motivationCard: {
        tabs: {
            salesRankMonthly: "Ranking miesięczny",
            salesRankQuarterly: "Ranking kwartalny",
        },
        headers: {
            salesRank: {
                targetCompletionRank: "Ranking realizacji celów sprzedażowych",
                reportDate: (startDate?: string | undefined) => `Wyniki wg stanu na dzień ${startDate}`,
                rankPosition: "Pozycja",
                change: "Zmiana",
                planTargetValue: "Realizacja planu / Plan",
                tableHeader: "Ranking realizacji celów sprzedażowych - szczegóły",
            },
        },
    },
    view360Card: {
        getLoaderMessage: `Wczytywanie danych...`,
        loadingReports: "Ładowanie raportów...",
        view360: "Widok 360",
        tabs: {
            generalInformation: "Informacje ogólne",
            employees: "OFWCA",
            sales: "Sprzedaż",
            notes: "Notatki",
        },
        search: {
            moreResultsAvailable: (limit: number) => {
                return `Wyszukano pierwsze ${limit} wyników`;
            },
            toNarrowResults: "Aby zawęzić liczbę wyników doprecyzuj zapytanie",
            noResults: "Nie znaleźliśmy wyników dla Twojego zapytania.",
            searchTitle: "Wyszukaj agencję i OFWCA",
            search: "Szukaj",
            results: "Wyniki",
            openView360: "Otwórz widok 360",
            tooltipLine1: "Aby wyszukać agencję wpisz: numer pośrednika lub nazwę pośrednika.",
            tooltipLine2: "Aby wyszukać OFWCA wpisz: imię i nazwisko OFWCA lub nr PUNU lub 6 pierwszych cyfr PESEL.",
            resultsTable: {
                type: "Typ",
                name: "Numer/Nazwa",
                status: "Status",
                details: "Szczegóły",
                action: "Akcja",
            },
            error: "Wystąpił błąd podczas wyszukiwania",
        },
        generalInformations: {
            intermediaryNumber: "Nr pośrednika",
            status: "Status",
            pd: "PD",
            dpd: "DPD",
            rms: "RMS",
            startEhm: "Data od EHM",
            startEhz: "Data od EHŻ",
            representatives: "Właściciele i reprezentanci",
            agencyRegistrationData: "Adres rejestrowy agencji",
            locations: "Adresy punktów obsługi",
            profiles: "Powiązane profile",
            owner: "właściciel",
            representative: "reprezentant",
            nip: "NIP",
            regon: "REGON",
            salesPerson: {
                punuId: "PUNU",
                status: "Status",
                birthDate: "Data urodzenia",
                systemLogin: "Login systemowy",
                infoPortalRegistration: "Rejestracja Infoportal EHM/EHŻ",
                phoneNo: "Telefon EHM/EHŻ",
                emailAddress: "Adresy e-mailowe EHM/EHŻ",
                marketingConsents: "Zgody marketingowe EHM/EHŻ",
                knf: "Data rejestracji KNF EHM/EHŻ",
                iPunktUserStatus: "iPunkt status użytkownika",
                coins: "Zdobyte monety łącznie/wypłacone",
                certification: "Certyfikacja",
                training: {
                    header: "Szkolenia",
                    date: "Data szkolenia",
                    name: "Nazwa szkolenia",
                    tenantCode: "Spółka",
                    hoursCount: "L. godzin",
                    type: "Rodzaj",
                    workTraining: "Zawodowe",
                    completed: "Zaliczenie",
                    year: "Rok",
                },
                ofwcaProfile: {
                    header: "Numery agencyjne powiązane z OFWCA",
                    name: "Nazwa",
                    number: "Numer agencji",
                    role: "Rola",
                    access: "Uprawnienia",
                },
            },
        },
        profilesTable: {
            title: "Powiązane profile",
            number: "Nr profilu",
            tenant: "Spółka",
            channel: "Kanał dystrybucji",
            distributionGroup: "Grupa dystrybucji",
            proxy: "Pełnomocnictwo",
            pd: "PD",
            dpd: "DPD",
            rms: "RMS",
            status: "Status",
            profileNumberList: "Numery profili",
        },
        contractsTable: {
            title: "Kontrakty sprzedażowe",
            fromTo: "Okres",
            type: "Rodzaj",
            status: "Status",
            period: "Typ",
        },
        commissionTable: {
            title: "Tabele prowizyjne",
            line: "Pion",
            group: "Grupa",
            sum: "Stawka (suma)",
            baseRate: "Stawka bazowa",
            dynamicsRate: "Bonus za dynamikę",
            locationRate: "Bonus za lokal",
            claimRatioRate: "Czynnik szkodowości",
            yearGroup: "Rok trwania umowy ubezpieczenia / wielkość grupy",
            rate: "Stawka",
        },
        employeesList: {
            loading: "Ładowanie OFWCA...",
            punuId: "PUNU",
            fullName: "Nazwisko Imię",
            companies: "Spółki",
            employeesList: {
                noEmployeesFound: "Nie znaleziono OFWCA.",
            },
            errors: {
                failedToFetchEmployees: "Wystąpił problem podczas wczytywania OFWCA.",
            },
        },
        reports: {
            reportDate: (companyName: string, startDate: string) => `${companyName}: ${startDate}`,
            fetchingReportsConfiguration: "Pobieranie konfiguracji raportów...",
            customers: "Klienci",
            salesAndActivitySectionTitle: "Sprzedaż i aktywność",
            salesSubSectionTitle: (company: string) => `Sprzedaż ${company}`,
            activitySubSectionTitle: (company: string) => `Aktywność ${company}`,
            otherParameters: "Pozostałe parametry",
            errors: {
                failedToFetchReportsConfigurationErrorMessage:
                    "Wystąpił problem podczas pobierania konfiguracji raportów.",
                noReportsConfiguration: "Brak konfiguracji raportów.",
                failedToFetchOverviewReportsErrorMessage: (company: string) =>
                    `Wystąpił problem podczas pobierania raportów ${company}.`,
                failedToFetchCustomerReportErrorMessage: (company: string) =>
                    `Wystąpił problem podczas pobierania klientów ${company}.`,
                failedToFetchOtherParametersReportErrorMessage: (company: string) =>
                    `Wystąpił problem podczas pobierania innych parametrów ${company}.`,
                failedToFetchSalesReportErrorMessage: (company: string) =>
                    `Wystąpił problem podczas pobierania sprzedaży ${company}.`,
                failedToFetchActivityReportErrorMessage: (company: string) =>
                    `Wystąpił problem podczas pobierania aktywności ${company}.`,
            },
        },
        notes: {
            notesList: {
                noNotesFound: "Nie znaleziono notatek.",
                searchPlaceholder: "Szukaj",
                addNewNote: "Nowa notatka",
                showMoreNotes: "Pokaż więcej",
                loading: "Wczytywanie...",
            },
            errors: {
                noIdSpecifed: "Nie określono ID sprzedawcy ani ID pośrednika sprzedaży.",
                failedToFetchNotes: "Wystąpił problem podczas wczytywania notatek.",
            },
            emptyContent: "Wybierz notatkę z listy",
        },
    },
    powerBiReports: {
        noReports: "Brak udostępnionych raportów",
        initializingReports: "Wczytywanie raportów...",
        loadingReportPages: "Wczytywanie stron raportu...",
    },
    feedback: {
        textAreaPlaceholder: "Opisz co Ci się spodobało lub co mogłoby być lepiej.",
        invitationMessage: "Pomóż nam rozwijać PinPoint dzieląc się z nami swoją opinią",
        thankYouMessage: "Dziękujemy za podzielenie się swoją opinią",
        title: "Podziel się swoją opinią",
    },
    userProfile: {
        title: "Administracja",
    },
    notes: {
        details: {
            intermediaryName: "Nazwa pośrednika",
            createdAt: "Utworzono",
            modifiedAt: "Zmodyfikowano",
            type: "Typ notatki",
            contactDate: "Data notatki/kontaktu",
            topics: "Omawiane tematy",
            noteBody: "Notatka",
        },
        errors: {
            typeError: "Wybierz typ notatki.",
            bodyError: "Uzupełnij treść notatki.",
            intermediaryListError: "Wybierz przynajmniej 1 agencję.",
        },
        confirmNoteDeletion: "Czy na pewno chcesz usunąć notatkę?",
        pickNoteType: "Wybierz typ notatki",
        addNoteContent: "Dodaj treść notatki",
        selectNote: "Wybierz notatkę z listy",
    },
};

export default pl;
